
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-width":"1.1","d":"M14 15.1H3A1.1 1.1 0 0 1 1.9 14V3A1.1 1.1 0 0 1 3 1.9h11A1.1 1.1 0 0 1 15.1 3v11a1.1 1.1 0 0 1-1.1 1.1Z"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-width":"1.1","d":"M11.8 12.9h-1.1a1.1 1.1 0 0 1-1.1-1.1V8.5a1.1 1.1 0 0 1 1.1-1.1h1.1a1.1 1.1 0 0 1 1.1 1.1v3.3a1.1 1.1 0 0 1-1.1 1.1Z"}})])
          )
        }
      }
    